<script>
import {Link} from "@inertiajs/vue3";
import IconArrowRight from "@js/components/Icons/IconArrowRight.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import {Autoplay} from 'swiper/modules';
import "swiper/css";

export default {
    name: "HomeTopCardSlider",
    components: {SwiperSlide, Swiper, IconArrowRight, Link},
    data() {
        return {
            slides: [
                {
                    title: "Поставка и продажа дорожных плит",
                    description: "Мы предлагаем широкий ассортимент железобетонных дорожных плит",
                },
                {
                    title: "Доставка и выгрузка на объект",
                    description: "Доставка и разгрузка дорожных плит – важный этап в строительстве, требующий профессионального подхода.",
                },
                {
                    title: "Монтаж и укладка плит",
                    description: "Профессиональный монтаж дорожных плит – залог их долговечности и надежности.",
                }
            ],
            currentSlide: 0,
            intervalId: null,
        };
    },
    methods: {
        setSwiper(swiperInstance) {
            this.swiper = swiperInstance;
        },
        slideNext() {
            if (this.swiper) this.swiper.slideNext();
        },
        slidePrev() {
            if (this.swiper) this.swiper.slidePrev();
        },
    },
    setup() {
        return {
            modules: [Autoplay]
        }
    }
};
</script>


<template>
    <div
        class="backdrop-blur-sm bg-black/30 border border-[#FFFFFF80] w-full min-h-[250px] rounded-2xl p-5 relative overflow-hidden">
        <!-- Слайды с анимацией -->
        <Swiper :slides-per-view="1"
                :space-between="20"
                :autoplay="{
                         delay: 50000,
            disableOnInteraction: false
                    }"
                @swiper="setSwiper"
                :modules="modules"
                :loop="true"
                class="w-full">
            <SwiperSlide v-for="(slide, index) in slides" :key="index"
            class="min-h-[155px]">
                <p class="text-white text-lg font-bold mb-3">
                    {{ slide.title }}
                </p>
                <p class="text-sm font-normal text-white mb-3">
                    {{ slide.description }}
                </p>
                <Link :href="route('services')"
                      class="px-3 py-2 text-xs font-medium text-center text-white bg-indigo-700 rounded-lg hover:bg-indigo-800">
                    Больше об услугах
                </Link>
            </SwiperSlide>
        </Swiper>

        <!-- Стрелки для навигации -->
        <div class="absolute bottom-5 right-5 flex space-x-3">
            <button @click="slidePrev" aria-label="Назад"
                    class="border border-[#FFFFFF80] active:border-indigo-600 active:text-indigo-600 text-white rounded-full w-10 h-10 flex items-center justify-center">
                <IconArrowRight class="w-6 h-6 rotate-180"/>
            </button>
            <button @click="slideNext" aria-label="Вперед"
                    class="border border-[#FFFFFF80] active:border-indigo-600 active:text-indigo-600 text-white rounded-full w-10 h-10 flex items-center justify-center">
                <IconArrowRight class="w-6 h-6"/>
            </button>
        </div>
    </div>
</template>
